import React from 'react';
import IconPack from './IconPack';

const SVGIcon = ({name}) => {
  const SVG = IconPack[name];
  return <React.Fragment>{SVG}</React.Fragment>;
}

export default SVGIcon;